import NodeRSA from 'node-rsa';
import CryptoJS from 'crypto-js';

// Encrypt the password using the public key
const Encryption = {
  encrypt: (publicKeyData, payload) => {
    const publicKey = Buffer.from(publicKeyData, 'base64').toString();
    const key = new NodeRSA(publicKey);
    return key.encrypt(payload, 'base64');
  },
  AESdecryptData: (encodedData) => {
    const encryptionKey = '93ffa3bcd7f58acfb899952aa235ffbc';
    const key = CryptoJS.enc.Utf8.parse(encryptionKey);
    const decodedData = window.atob(encodedData);
    const iv = CryptoJS.enc.Utf8.parse(encryptionKey.slice(0, 16));
    const decrypted = CryptoJS.AES.decrypt(decodedData, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  },
};

export default Encryption;
